// eslint-disable-next-line
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer'; // polyfill for lozad
import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueGtm from '@gtm-support/vue2-gtm';
import VueScrollTo from 'vue-scrollto';
import VueLazyload from 'vue-lazyload';
import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';
import VueConfirmDialog from 'vue-confirm-dialog';
// import VuePrism from 'vue-prism';
import fileSize from 'filesize';


// import api from '@/api/index.js';
import player from '@motionelements/helper/player/index.js';

import cookies from 'js-cookie';
import VueClipboard from 'vue-clipboard2';

import uuid from 'uuid/v4'; // upload file id generate
import _ from 'lodash';

import {
  format,
  set,
  fromUnixTime,
  getUnixTime,
  parseISO,
  // differenceInSeconds,
  // differenceInDays,
  differenceInMonths,
  isSameYear,
  getTime,
  getYear,
  getQuarter,
  addMonths,
  subMonths,
  startOfMonth,
  endOfMonth,
} from 'date-fns';

import {
  ja,
  ko,
} from 'date-fns/locale';

import meHelper from '@motionelements/helper';


// eslint-disable-next-line
import {
  VBScrollspyPlugin,
  TablePlugin,
  ImagePlugin,
  EmbedPlugin,
  ModalPlugin,
  TooltipPlugin,
  PaginationPlugin,
  CollapsePlugin,
  DropdownPlugin,
  SidebarPlugin,
} from 'bootstrap-vue';
import VTooltip from 'v-tooltip';
import Rollbar from 'vue-rollbar';

import link from '@motionelements/core/src/helpers/link.js';
import date from '@motionelements/core/src/helpers/date.js';
// init services store
import { setStore as setAccountServiceStore } from '@motionelements/core/src/services/account.service.js';
import { setStore as setAppServiceStore } from '@motionelements/core/src/services/app.service.js';
import { setStore as setNotificationServiceStore } from '@motionelements/core/src/services/notification.service.js';
import { setStore as setApiStore } from '@motionelements/core/src/api/base-api-v2';
import { setStore as setLanguageStore } from '@motionelements/core/src/services/language.service.js';
import { EventBus } from '@motionelements/core/src/services/event-bus.service.js';

import iconBase from '@motionelements/assets/src/js/me-font/icons-base.js';

import meHelperMoney from '@/helpers/money.js';

import App from './App.vue';
import router from './router';
import store from './store';

import i18n from './lang/i18n.js';

import iconFont from './assets/js/me-font/icons-artist.js';

// eslint-disable-next-line no-unused-expressions
import(/* webpackPrefetch: true */'bootstrap');

const isProduction = process.env.VUE_APP_ENV === 'production';

Vue.use(VueMeta, {
  keyName: 'head', // compatible with Nuxt
  tagIDKeyName: 'hid', // compatible with Nuxt
});
// Vue.use(VueI18n);
Vue.use(VueScrollTo, { duration: 800 });
Vue.use(iconBase);
Vue.use(iconFont);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VBScrollspyPlugin);
Vue.use(TablePlugin);
Vue.use(ImagePlugin);
Vue.use(EmbedPlugin);
Vue.use(ModalPlugin);
Vue.use(TooltipPlugin);
Vue.use(PaginationPlugin);
Vue.use(CollapsePlugin);
Vue.use(DropdownPlugin);
Vue.use(SidebarPlugin);
Vue.use(VTooltip, {
  defaultTrigger: 'click hover',
});
Vue.use(VueConfirmDialog);
Vue.use(VueClipboard);

Vue.prototype.$VueBus = new Vue();

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 2,
});

Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

Vue.use(VueGtm, {
  // container id
  id: process.env.VUE_APP_GTM_ID,
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth: process.env.VUE_APP_GTM_AUTH,
  //   gtm_preview: process.env.VUE_APP_GTM_PREVIEW,
  //   gtm_cookies_win: 'x',
  // },
  vueRouter: router,
  // enable track or not (optional)
  enabled: !['testing'].includes(process.env.VUE_APP_ENV),
  // display console logs debugs or not (optional)
  // debug: (['production', 'stage'].indexOf(process.env.NODE_ENV) < 0),
  debug: !isProduction,
});

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  hostSafeList: ['motionelements.com', 'cloudfront.net'],
  captureUncaught: !isProduction,
  captureUnhandledRejections: !isProduction,
  verbose: !isProduction,
  enabled: ['production', 'staging'].includes(process.env.VUE_APP_ENV),
  environment: process.env.VUE_APP_ENV,
});

setAccountServiceStore(store);
setLanguageStore(store);
setAppServiceStore(store);
// setEventServiceStore(store);
setNotificationServiceStore(store);
setApiStore(store);

Vue.prototype._ = _;
// eslint-disable-next-line no-underscore-dangle
Vue.prototype.$_ = _; // use $_ for Nuxt compatiblity
Vue.prototype.$scrollToTop = () => window.scrollTo({ top: 0 });
Vue.prototype.$scrollTo = (selector) => { document.querySelector(selector).scrollIntoView({ behavior: 'smooth' }); };
Vue.prototype.uuid = uuid;
Vue.prototype.$cookies = cookies;

Vue.prototype.$dateFns = {};
Vue.prototype.$dateFns.format = format;
Vue.prototype.$dateFns.set = set;
Vue.prototype.$dateFns.fromUnixTime = fromUnixTime;
Vue.prototype.$dateFns.getUnixTime = getUnixTime;
Vue.prototype.$dateFns.parseISO = parseISO;
// Vue.prototype.$dateFns.differenceInSeconds = differenceInSeconds;
// Vue.prototype.$dateFns.differenceInDays = differenceInDays;
Vue.prototype.$dateFns.differenceInMonths = differenceInMonths;
Vue.prototype.$dateFns.isSameYear = isSameYear;
Vue.prototype.$dateFns.getTime = getTime;
Vue.prototype.$dateFns.getYear = getYear;
Vue.prototype.$dateFns.getQuarter = getQuarter;
Vue.prototype.$dateFns.addMonths = addMonths;
Vue.prototype.$dateFns.subMonths = subMonths;
Vue.prototype.$dateFns.startOfMonth = startOfMonth;
Vue.prototype.$dateFns.endOfMonth = endOfMonth;
Vue.prototype.$dateFns.locale = {};
Vue.prototype.$dateFns.locale.ja = ja;
Vue.prototype.$dateFns.locale.ko = ko;


Vue.prototype.$audioPlayer = player.audioPlayer;
Vue.prototype.$videoPlayer = player.videoPlayer;
Vue.prototype.$player = player;

Vue.prototype.$term = meHelper.term;
Vue.prototype.$siteUrl = meHelper.siteUrl;
Vue.prototype.$site = meHelper.site;
Vue.prototype.$link = link;
Vue.prototype.$wbr = meHelper.wbr;
Vue.prototype.$date = date;

Vue.prototype.$money = {};
Vue.prototype.$money.format = meHelperMoney.moneyFormatter;

Vue.prototype.$fileSize = fileSize;
Vue.prototype.$hasOwnProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
Vue.prototype.$bus = EventBus;

Vue.config.errorHandler = function (err, vm) {
  if (!isProduction) {
    vm.$rollbar.error(err);
    throw err;
  }
};

Vue.config.productionTip = true;
Vue.config.devtools = !isProduction;
Vue.config.performance = !isProduction;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
